import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import StatsStrip from './components/StatsStrip';
import About from './components/About';
import Disciplines from './components/Disciplines';
import Goals from './components/Goals';
import Quote from './components/Quote';
import Events from './components/Events';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-950">
      <Navbar />
      <main>
        <Hero />
        <StatsStrip />
        <About />
        <Disciplines />
        <Goals />
        <Quote />
        <Events />
      </main>
      <Footer />
    </div>
  );
}